import { Base } from "src/app/shared/model/core/base.model";
import { EvidenciaOportunidad } from "src/app/shared/model/gestion-proyectos/evidenciasOportunidad";

export class comentariosOportunidad extends Base {
    idGit: number;
    idComentario: number;
    contenido: string;
    estado: string
    fecha: string;
    idUser: number;
    username: string;
    nombreUsuario:string;
    archivosComentarios: EvidenciaOportunidad[];   
    estatus:string;
}